import $ from 'jquery';
export default class SelectOnlyOneValue {
    static $element = $('.js__select-only-one-value');
    static init() {
        if (this.$element.length) {
            this.initActions();
        }
    }
    static initActions() {
        const $inputs = this.$element.find('input');
        const values = this.$element.data('values').split(',');
        $inputs.on('change', e => {
            const $input = $(e.currentTarget);
            const inputValue = String($input.val());
            const isChecked = $input.is(':checked');
            if (isChecked && values.includes(inputValue)) {
                const valuesToDisable = values.filter(value => inputValue != value);
                valuesToDisable.forEach(valueToDisable => {
                    this.$element.find(`[value="${valueToDisable}"]`).prop('checked', false);
                });
            }
        });
    }
}
